<template>
  <section class="itemVideo">
    <el-upload
      v-if="!isMaxHidden"
      ref="uploadRef"
      :style="{ width: width + 'px', height: height + 'px' }"
      :action="action"
      accept=".jpg,.jpeg,.png"
      :show-file-list="false"
      :multiple="limit > 1"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-success="onSuccessUpload"
      :on-exceed="onExceed"
    >
      <i class="el-icon-plus itemVideo-btn">
        <span v-show="isUploading">正在上传...</span>
        <span v-if="!isUploading"> 只能上传mp4文件，最多上传{{ limit }}张</span>
      </i>
    </el-upload>
  </section>
</template>

<script>
export default {
  name: 'ItemVideo',
  components: {},
  props: {
    // imgs
    value: {
      type: Array,
      default() {
        return []
      }
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    // upload
    action: {
      type: String,
      default: '/api/FileUpload/DebtAudit'
    },
    // 限制上传的图片数量(单图上传就是已传图片和上传按钮重叠)
    limit: {
      type: Number,
      default: 1
    },
    // 限制上传图片的文件大小(kb)
    size: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      isUploading: false, // 正在上传状态
      isFirstMount: true // 控制防止重复回显
    }
  },
  computed: {
    list: {
      get() {
        return this.value
      },
      set(val) {
        if (val.length < this.list.length) {
          // 判断是删除图片时同步el-upload数据
          this.syncElUpload(val)
        }
        // 同步v-model
        this.$emit('input', val)
      }
    },
    // 控制达到最大限制时隐藏上传按钮
    isMaxHidden() {
      return this.list.length >= this.limit
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.isFirstMount && this.value.length > 0) {
          this.syncElUpload()
        }
        if (val.length == 0 && this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      },
      deep: true
    }
  },
  mounted() {
    // TODO:这行代码报错
    // if (this.value.length > 0) {
    //   this.syncElUpload();
    // }
  },
  methods: {
    // 同步el-upload数据
    syncElUpload(val) {
      const list = val || this.list
      this.$refs.uploadRef.uploadFiles = list.map((v, i) => {
        return {
          name: 'pic' + i,
          url: v.url,
          status: 'success'
        }
      })
      this.isFirstMount = false
    },
    // 上传图片之前
    beforeUpload() {
      this.isFirstMount = false
      this.isUploading = true
    },
    // 上传完单张图片
    onSuccessUpload(res, file, fileList) {
      // 这里需要根据你自己的接口返回数据格式和层级来自行修改
      if (res.data.length > 0) {
        // 判断接口上传成功
        if (this.list.length < this.limit) {
          // 未超限时，把接口返回的图片url地址添加到imgList
          const obj = {}
          obj.url = res.data[0]
          this.list.push(obj)
          this.$emit('add', res.data)
        }
      } else {
        // 判断接口上传失败
        this.syncElUpload()
        this.$message({ type: 'error', message: res.msg })
      }
      this.isUploading = false
    },
    // 超限
    onExceed() {
      this.$refs.uploadRef.abort() // 取消剩余接口请求
      this.syncElUpload()
      this.$message({
        type: 'warning',
        message: `图片超限，最多可上传${this.limit}张图片`
      })
    }
  }
}
</script>

<style scoped lang="scss">
.itemVideo {
  &-btn {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    @include fun-border();
    background-color: #fbfdff;
    border-radius: 6px;
    font-size: 20px;
    color: #999;
    > span {
      position: absolute;
      bottom: 10%;
      left: 0;
      width: 100%;
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>
